import React from "react";
import WorkCasePage from "../components/workcase/WorkCasePage";
import imgSpectaris from "../assets/img/img-work-spectaris.png";

function Spectaris() {
  return (
    <WorkCasePage
      title="Spectaris"
      heroImage={imgSpectaris}
      heroAlt="Spectaris Trendforum — Design und Umsetzung"
    >
      <p>
        Komplettes Design für das Trendforum und Entwicklung auf WordPress-Basis
        — von ersten Layouts über Komponenten bis zur auslieferungsfertigen Site.
      </p>
      <p>
        Fokus auf klare Informationsarchitektur, Editorial-Flächen und ein
        System, das Redaktion und Marketing im Alltag gut bedienen kann.
      </p>
    </WorkCasePage>
  );
}

export default Spectaris;
